export default __webpack_public_path__ + "static/media/PlayerStatisticsBackground.072b9430.png";